import {AutomaticMailStep, Step} from 'api';
import linkifyHtml from 'linkify-html';
import * as Yup from 'yup';

interface AutomaticMailStepType extends Step {
  steppable: AutomaticMailStep;
}

interface Props {
  step: AutomaticMailStepType;
}

const useAutomaticMailForm = ({step}: Props) => {
  const convertUrlToLink = (text: string) =>
    linkifyHtml(text, {
      defaultProtocol: 'https',
      rel: 'noopener noreferrer',
      target: '_blank',
    });
  const convertClassToInlineStyle = (text: string) =>
    text.replace(/class="ql-align-center"/g, 'style="text-align: center"');
  const convertBodyHtml = (text: string) =>
    convertUrlToLink(convertClassToInlineStyle(text));

  const mail = step.steppable?.automaticMail;
  const initialValues = {
    fromEmail: mail?.fromEmail || '',
    fromName: mail?.fromName || '',
    subject: mail?.subject || '',
    bodyText: mail?.bodyText || '',
    bodyHtml: mail?.bodyHtml || '',
    cc: mail?.cc || [],
    bcc: mail?.bcc || [],
  };

  const validationSchema = Yup.object().shape({
    fromEmail: Yup.string().email().required('必須項目です'),
    subject: Yup.string().required('必須項目です'),
    bodyText: Yup.string(),
    bodyHtml: Yup.string(),
  });

  return {
    convertBodyHtml,
    initialValues,
    validationSchema,
  };
};

export default useAutomaticMailForm;
